import {Injectable, NgZone} from "@angular/core";
import {FiDebugInfoService} from "@fi-shared/fi-shared-services/fi-debug-info.service";

export enum FicQRScanError {
    USER_CANCEL,
    INVALID_FORMAT
    // ...
}

export class FicQRAction {

    public static TYPE_CHECKPOINT = 'checkpoint';
    public static TYPE_UNIT_ID = 'unit-id';

    public parsedData: any;

    constructor(public type: string,
                public data: string
    ) {
    }

    public static fromString(code: string): FicQRAction {
        const match = code.match(/^([^:]+):(.+)$/);
        if (match) {
            const actionType = match[1];
            const actionData = match[2];
            const action = new FicQRAction(actionType, actionData);
            switch (actionType) {
                case FicQRAction.TYPE_CHECKPOINT:
                    const checkpointMatch = actionData.match(/^(\d+)-(\d+)$/);
                    if (checkpointMatch) {
                        action.parsedData = {
                            checklistId: parseInt(checkpointMatch[1]),
                            checkpoint: parseInt(checkpointMatch[2])
                        };
                        return action;
                    }
                    break;
                case FicQRAction.TYPE_UNIT_ID:
                    const unitId = parseInt(actionData);
                    if (!isNaN(unitId)) {
                        action.parsedData = {
                            unitId: unitId
                        };
                        return action;
                    }
                    break;
            }
        }
        return null;
    }

    public static getQRCodeForCheckpoint(checkpoint: { SortIndex: number }, checklist: { Id: number }) {
        return (checklist && checkpoint) ? `checkpoint:${checklist.Id}-${checkpoint.SortIndex}` : '';
    }

    public static getQRCodeForBusinessUnit(businessUnit: { Id: number }) {
        return businessUnit ? `unit-id:${businessUnit.Id}` : '';
    }
}

@Injectable()
export class FicScanQRCodeService {

    constructor(private zone: NgZone,
                private debugInfoService: FiDebugInfoService,) {
    }

    scan(): Promise<FicQRAction> {
        return new Promise((resolve, reject) => {

            cordova.plugins.barcodeScanner.scan(
                (result: any) => this.zone.run(() => {
                    this.debugInfoService.addInfo('QR code ' + JSON.stringify(result));
                    if (result.cancelled) {
                        reject(FicQRScanError.USER_CANCEL);
                    } else {
                        const action = FicQRAction.fromString(result.text);
                        if (action) {
                            resolve(action);
                        } else {
                            reject(FicQRScanError.INVALID_FORMAT);
                        }
                    }
                }), (err) => this.zone.run(() => {
                    this.debugInfoService.addInfo('QR code err ' + JSON.stringify(err))
                    reject(err);
                }), {
                    preferFrontCamera: false, // iOS and Android
                    showFlipCameraButton: true, // iOS and Android
                    showTorchButton: true, // iOS and Android
                    torchOn: false, // Android, launch with the torch switched on (if available)
                    saveHistory: false, // Android, save scan history (default false)
                    prompt: "Place a barcode inside the scan area", // Android
                    resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
                    // formats : "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
                    // orientation : "landscape", // Android only (portrait|landscape), default unset so it rotates with the device
                    disableAnimations: false, // iOS
                    disableSuccessBeep: false // iOS and Android
                }
            );
        });
    }
}
